var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:'scroll-container d-flex flex-column ' + _vm.containerClass},[_c('div',{staticClass:"header pa-0",class:_vm.isScrolled ? `elevation-${_vm.elevation}` : ''},[_vm._t("header")],2),_c('div',{ref:"scroller",staticClass:"scrollable pa-0 flex-grow-1"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }